import {Button} from "@mui/material";

interface ButtonAddEmptyUnteraufgabeProps {
    id: string;
    push: (value: any) => void;
    newIndex: number;
    aufgabeId: string;
    mandantId: string;
}

export default function ButtonAddEmptyUnteraufgabe({
                                                       id,
                                                       push,
                                                       newIndex,
                                                       aufgabeId,
                                                       mandantId
                                                   }: ButtonAddEmptyUnteraufgabeProps
) {
    return (
        <Button id={id}
            variant="outlined"
            onClick={() => {
                push({
                    id: `neu-${newIndex}`,
                    titel: "",
                    beschreibung: "",
                    reihenfolge: newIndex,
                    prompt: "",
                    antworttyp: "Boolean",
                    gewichtung: 0,
                    aufgabeId: aufgabeId,
                    mandantId: mandantId,
                    pflichtfeld: false,
                    nurAuswertung: false,
                    noRescheduleOnResponseValue: null,
                });
            }
            }
        >
            + Neue Unteraufgabe
        </Button>
    );
}